import {
  GetMySocialMediaClient,
  GetCompanySellerList,
  SetClientDetail2Seller,
  SaveMediaOperatorNote,
  GetSocialMediaDashboardData
} from '@/api/socialmedia'

const state = {}

const mutations = {}

const actions = {
  getMySocialMediaClient({commit}, params) {
    return new Promise((resolve, reject) => {
      GetMySocialMediaClient(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  getCompanySellerList({commit}, params) {
    return new Promise((resolve, reject) => {
      GetCompanySellerList(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  setClientDetail2Seller({commit}, params) {
    return new Promise((resolve, reject) => {
      SetClientDetail2Seller(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  saveMediaOperatorNote({commit}, params) {
    return new Promise((resolve, reject) => {
      SaveMediaOperatorNote(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getSocialMediaDashboardData({commit}, params) {
    return new Promise((resolve, reject) => {
      GetSocialMediaDashboardData(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
